export const isFunction = (value: any) => {
    return Object.prototype.toString.call(value) === '[object Function]'
}

export const isObject = (obj:any):boolean => {
    return obj !== null && typeof obj === 'object'
}

export const isString = (str: string):boolean => {
    return typeof str === 'string'
}

export const  stringify = (obj, sep = '&', eq = '=') => {
    let str = "";
    for (var k in obj) {
        str += k + eq + unescape(obj[k]) + sep
    }
    return str.slice(0, -1)
}